



















































































import MenuLink from '@/components/MenuLink.vue'
import MenuLinkCategory from '@/components/MenuLinkCategory.vue'
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'
import searcherry from '@/services/Searcherry/Searcherry'
import { ExitEventData } from '@/services/Statistic/PostData'

@Component({
  name: 'search-result',
  components: {
    MenuLinkCategory,
    MenuLink
  }
})
export default class SearchResult extends Vue {
  @Prop() searchResults: any
  @PropSync('searchPhraseProp', { type: String }) searchPhrase!: string

  isMenuOpen = false
  srchrryTrnSidebar = ''
  srchrryTrnSidebarItems = ''
  oldSearchLink = searcherryConfig.oldSearchLink
  initSearchPhraseTip = searcherryConfig.initSearchPhraseTip
  searchPhraseHistory: Array<string> = []
  isSearchRowFixed = searcherryConfig.isSearchRowFixed
  isAnimationEnabled = searcherryConfig.isAnimationEnabled

  created () {
    this.srchrryTrnSidebar = this.isAnimationEnabled ? 'srchrry-trn-sidebar' : ''
    this.srchrryTrnSidebarItems = this.isAnimationEnabled ? 'srchrry-trn-sidebar-items' : ''
    this.loadSearchPhraseHistory()
  }

  toggleMenu () {
    this.isMenuOpen = !this.isMenuOpen
  }

  loadSearchPhraseHistory () {
    let json = localStorage.getItem('searchPhrasesJson')
    this.searchPhraseHistory = (json !== null) ? JSON.parse(json) : []
    this.searchPhraseHistory = this.searchPhraseHistory.filter((value) => {
      return value.trim() !== ''
    }).slice(0, 10)
  }

  @Watch('$route')
  onRouteChanged (to: Route, from: Route) {
    this.isMenuOpen = false
    this.loadSearchPhraseHistory()
  }

  @Watch('searchResults')
  onSearchResultChanged (to: any) {
    this.$nextTick(function () {
      let contentMarginTop = 0

      let el = document.getElementById('srchrry-header')
      if (el !== null) {
        contentMarginTop = el.clientHeight
      }

      let mainEl = document.getElementById('srchrry-content')
      if (mainEl !== null) {
        if (this.isSearchRowFixed || (this.searchPhrase.length > 18 && to.totalFound > 0)) {
          mainEl.style.marginTop = null
        } else {
          mainEl.style.marginTop = contentMarginTop === 0 ? null : -contentMarginTop + 'px'
        }
      }
    })
  }

  oldSearchClick () {
    let data = new ExitEventData()
    data.searchPhrase = this.$route.params.searchPhrase
    searcherry.statisticService.exitWithOldSearchEvent(data)

    searcherry.generateEvent('click-old-search')
  }
}
